module.exports = function (app) {
	'use strict';

	app.service('employeeFinder', ['services', function(services) {
		this.results = null;
		this.searchData = null;
		this.nextSearchData = null;
		this.eggWasLaid = false;
		this.isSearching = false;

		this.purge = function() {
			this.results = null;
			this.searchData = null;
			this.nextSearchData = null;
			this.eggWasLaid = false;
			this.isSearching = false;
		}.bind(this);

		this.search = function(searchData, isViewNext) {
			if (!(searchData &&
				searchData instanceof Object &&
				Object.keys(searchData).filter(
					function(x) {
						return searchData[x] !== '' && searchData[x] !== null && searchData[x] !== undefined;
					}
				).length)
			) { return; }

			this.isSearching = true;

			Object.keys(searchData).forEach(function(k) {
				if (!searchData[k]) {
					delete searchData[k];
				}
			});

			return services.eprsvc.employeesSearch().fetch(searchData).then(
				function(response) {
					this.eggWasLaid = false;
					this.isSearching = false;

					this.nextSearchData = response.searchData.listId
						? response.searchData
						: null;

					if (isViewNext) {
						this.results = this.results.concat(response.employees);
					}
					else {
						this.results = response.employees;
					}
				}.bind(this),

				function(error) {
					this.results = null;
					this.eggWasLaid = true;
					this.isSearching = false;
					return error;
				}.bind(this)
			);
		};

		this.viewNext = function() {
			return this.search(this.nextSearchData, true);
		}.bind(this);
	}]);


	app.directive('findEmployee', [function () {

		return {
			restrict: 'A',
			replace: false,
			transclude: true,
			templateUrl:'findEmployee.employerTemplate.html/directives/employee/findEmployee',

			scope: {
				showHeader: '=?',
				redirect: '=?',
				searchData: '=?'
			},

			controller: ['$state', '$scope',  'modal', 'services', 'sessionData', 'employeeFinder', 'coremetrics',
				function($state, $scope, modal, services, sessionData, employeeFinder, coremetrics) {


					$scope.entitlements = sessionData.entitlements;

					$scope.searchData = $scope.searchData || {};

					//changes for RF1240502 . Member id patter check to do alpha numeric only. Length check is happening in HTML
                    $scope.memberIdPattern = /^[a-zA-Z0-9]*$/;
                    var brands = ['6008','6009'];
                    $scope.headingAndPlaceHolder = (brands.indexOf(sessionData.employerInfo.brandName) > -1)? 'Member ID/SSN': 'Member ID/SSN/Client-Assigned ID'


                    $scope.searchEmployees = function(isValid) {
						if (!isValid || !($scope.searchData.lastName || $scope.searchData.groupNumber || $scope.searchData.memberId)) { return; }
						if ($state.$current.self.name == 'employee.enrollment') {
							coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:ENROLLMENT LANDING','EMPLOYERS:ENROLLMENT');
							coremetrics.elementTag('ENROLLMENT FIND EMPLOYEE SEARCH', 'EMPLOYERS:ASSIST ENROLLMENT');
						}
						if ($state.$current.self.name == 'home') {
							coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:HOME PAGE','EMPLOYERS:ENROLLMENT');
							coremetrics.elementTag('HOME PAGE FIND EMPLOYEE SEARCH', 'EMPLOYERS:HOME PAGE');
						}
						if ($scope.redirect) {
							employeeFinder.searchData = $scope.searchData;
							return $state.go('employee.find');
						}
						employeeFinder.search(angular.copy($scope.searchData));
					};

					$scope.clearListId = function() {
						delete $scope.searchData.listId;
					};

					$scope.clearForm = function() {
						$scope.searchData.lastName = '';
						$scope.searchData.groupNumber = '';
						$scope.searchData.memberId = '';
						$scope.searchData.listId = '';
						$scope.findEmployeeForm.$setPristine();
						$scope.findEmployeeForm.$setUntouched();
						employeeFinder.purge();
					};

					$scope.goToAdd = function() {
						if ($state.$current.self.name == 'employee.enrollment') {
							coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:ENROLLMENT LANDING','EMPLOYERS:ENROLLMENT');
							coremetrics.elementTag('ENROLLMENT ADD EMPLOYEE', 'EMPLOYERS:ENROLLMENT:LANDING PAGE');
						}
						if ($state.$current.self.name == 'home') {
							coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:HOME PAGE','EMPLOYERS:ENROLLMENT');
							coremetrics.elementTag('HOME PAGE ADD EMPLOYEE', 'EMPLOYERS:HOME PAGE:EMPLOYER LANDING PAGE');
						}
						$state.go('employee.add.subscriber');
					};
				}
			]
		};
	}]);
};
